'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _omit = require('lodash/object/omit');

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Logo = _react2['default'].createClass({
    displayName: 'Logo',
    render: function render() {
        return _react2['default'].createElement(
            'div',
            { className: 'm-app-topbar--logo' },
            _react2['default'].createElement(
                'a',
                { href: this.props.href },
                _react2['default'].createElement('img', (0, _omit2['default'])(this.props, ['app']))
            )
        );
    }
});

module.exports = Logo;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/app/header/logo.jsx
 ** module id = 818
 ** module chunks = 0 1
 **/